export function getParticipantDisplayName(chatThread) {
  if (!chatThread) {
    return 'unknown'
  }

  return chatThread.participant.displayName
}
export function getParticipant(chatThread) {
  if (!chatThread) {
    return null
  }
  return chatThread.participant
}
